import * as React from 'react';

import { useSelector } from 'react-redux';
import { Ecology } from '../../components/Ecology';
import { ecologyBlockActiveSelector } from '../../selectors/ecologyBlock';
import { getEcology } from '../../selectors/newbuilding';

// TODO: Удалить блок, фича-флаг выключен навсегда.
export function EcologyContainer() {
  const ecology = useSelector(getEcology);
  const isEcologyBlockActive = useSelector(ecologyBlockActiveSelector);

  if (!isEcologyBlockActive || !ecology || !ecology.length) {
    return null;
  }

  return <Ecology ecology={ecology} />;
}
